<template>
  <TransferVehicle />
</template>
<script>
import TransferVehicle from "@/components/master/transferTariff/TransferVehicle.vue";
export default {
  components: {
    TransferVehicle,
  },
  updated() {
    this.$helper.collapseMenu("buying-tariff");
    this.$helper.setNavigationClass("buying-transfer-link-new");
  },
};
</script>


// WEBPACK FOOTER //
// src/components/master/buyingTariff/TransferClassList.vue